// Central filter taxonomy for the Silver Screen Xchange marketplace
// Keep this file in sync with backend/server.py seed data.

export const CONTENT_TYPES = [
    "Feature Film",
    "Short Film",
    "Series / TV Drama",
    "Documentary",
    "Animation",
    "Web Series",
    "Music Video",
    "Experimental",
];

export const RIGHTS_TYPES = [
    "Full Copyright Ownership",
    "Territorial Rights",
    "Distribution Rights",
    "Streaming Rights",
    "Remake Rights",
    "Adaptation Rights",
    "A1 Rights",
];

export const REGIONS = [
    "Global",
    "Asia",
    "Europe",
    "North America",
    "South America",
    "Africa",
    "Oceania",
    "Middle East",
];

export const LANGUAGES = [
    "English",
    "Hindi",
    "Tamil",
    "Malayalam",
    "Telugu",
    "Bengali",
    "Sinhala",
    "Japanese",
    "Korean",
    "Mandarin",
    "Cantonese",
    "French",
    "Spanish",
    "Portuguese",
    "German",
    "Italian",
    "Arabic",
    "Persian",
    "Turkish",
    "Multi-language",
];

export const BUDGET_RANGES = [
    { key: "under_25k", label: "< $25K", min: 0, max: 25000 },
    { key: "25k_50k", label: "$25K – $50K", min: 25000, max: 50000 },
    { key: "50k_100k", label: "$50K – $100K", min: 50000, max: 100000 },
    { key: "100k_250k", label: "$100K – $250K", min: 100000, max: 250000 },
    { key: "250k_500k", label: "$250K – $500K", min: 250000, max: 500000 },
    { key: "500k_1m", label: "$500K – $1M", min: 500000, max: 1000000 },
    { key: "1m_5m", label: "$1M – $5M", min: 1000000, max: 5000000 },
    { key: "5m_10m", label: "$5M – $10M", min: 5000000, max: 10000000 },
    { key: "10m_25m", label: "$10M – $25M", min: 10000000, max: 25000000 },
    { key: "25m_50m", label: "$25M – $50M", min: 25000000, max: 50000000 },
    { key: "50m_100m", label: "$50M – $100M", min: 50000000, max: 100000000 },
    { key: "100m_plus", label: "$100M +", min: 100000000, max: null },
];

export const STAGES = [
    "Script Only",
    "In Pre-production",
    "In Production",
    "Post-production",
    "Completed",
    "Released",
];

export const GENRES = [
    "Action",
    "Adventure",
    "Comedy",
    "Drama",
    "Thriller",
    "Horror",
    "Romance",
    "Sci-Fi",
    "Fantasy",
    "Crime",
    "Mystery",
    "Biography",
    "Historical",
    "War",
    "Family",
    "Animation",
    "Musical",
    "Noir",
];

export const SUB_GENRES = {
    Action: ["Martial Arts", "Superhero", "Military", "Heist"],
    Comedy: ["Dark Comedy", "Romantic Comedy", "Satire", "Slapstick"],
    Drama: ["Legal", "Political", "Social", "Coming-of-age", "Family"],
    Thriller: ["Psychological", "Crime Thriller", "Conspiracy"],
    Horror: ["Supernatural", "Slasher", "Body Horror", "Folk Horror"],
    Romance: ["Period Romance", "Modern", "Tragic"],
    "Sci-Fi": ["Hard Sci-Fi", "Dystopian", "Space Opera", "Cyberpunk"],
    Fantasy: ["High Fantasy", "Urban Fantasy", "Fairy Tale"],
    Crime: ["Mob", "Noir", "Procedural"],
    Mystery: ["Whodunnit", "Detective", "Gothic"],
    Animation: ["2D Hand-drawn", "3D / CGI", "Stop-motion", "Anime"],
};

export const COPYRIGHT_STATUSES = ["Registered", "Pending", "Unregistered"];

// Convenience lookups
export function findBudgetKey(amount) {
    if (amount == null) return null;
    for (const b of BUDGET_RANGES) {
        if (amount >= b.min && (b.max == null || amount < b.max)) return b.key;
    }
    return null;
}

export function humanMoney(n) {
    if (n == null) return "—";
    if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 1)}M`;
    if (n >= 1_000) return `$${(n / 1_000).toFixed(0)}K`;
    return `$${n}`;
}
